import React from "react"

export default function NavbarBranding({ logo, logoXs, text, url }) {
  if (logo) {
    return (
      <div className="navbar-branding">
        {/* Static TBD logo */}
        <a href="https://thebuildingdecision.com/" className="navbar-static-logo" target="_blank" rel="noopener">
          <img src="/static/misago/img/TBD-Logo.png" alt="Static Brand Logo" style={{ height: '48px', width: 'auto' }} />
        </a>
        {/* Vertical divider */}
        <span className="navbar-logo-divider" style={{ 
          display: 'inline-block',
          width: '1px',
          height: '32px',
          backgroundColor: '#ddd',
          margin: '0 15px',
          verticalAlign: 'middle'
        }}></span>
        {/* Main branding logo */}
        <a href={url} className="navbar-branding-logo">
          <img src={logo} alt={text} style={{ height: '32px', width: 'auto' }} />
        </a>
      </div>
    )
  }

  return (
    <div className="navbar-branding">
      {/* Static TBD logo */}
      <a href="https://thebuildingdecision.com/" className="navbar-static-logo" target="_blank" rel="noopener">
        <img src="/static/misago/img/TBD-Logo.png" alt="Static Brand Logo" style={{ height: '48px', width: 'auto' }} />
      </a>
      {(logoXs || text) && (
        <span className="navbar-logo-divider" style={{ 
          display: 'inline-block',
          width: '1px',
          height: '32px',
          backgroundColor: '#ddd',
          margin: '0 15px',
          verticalAlign: 'middle'
        }}></span>
      )}
      {!!logoXs && (
        <a href={url} className="navbar-branding-logo-xs">
          <img src={logoXs} alt={text} style={{ height: '32px', width: 'auto' }} />
        </a>
      )}
      {!!text && (
        <a href={url} className="navbar-branding-text">
          {text}
        </a>
      )}
    </div>
  )
}
